// extracted by mini-css-extract-plugin
export default {"date-picker":"styles_date-picker__uYlOL","navigation":"styles_navigation__bJExk","counter":"styles_counter__co-Ml"};